import classes from "../Pages.module.css";
import { Row, Col, Tabs, Skeleton, message } from "antd";
import axios from "axios";
import DataContext from "../../../Context/dataContext";
import { useState, useEffect, useContext } from "react";
import BasicDetail from "./BasicDetail";
import SizeDetail from "./SizeDetail";
import TaxDetail from "./TaxDetail";
// import dayjs from "dayjs";
import SyncLoader from "react-spinners/SyncLoader";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const { TabPane } = Tabs;

const RequisitionView = (props) => {
  const { id } = useParams();
  const employeeData = useContext(DataContext);

  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [editDode, setEditDode] = useState(true);
  const [editTode, setEditTode] = useState(false);
  const [allData, setAllData] = useState(null);
  const [storeData, setStoreData] = useState(null);
  // const [editordMode1, setEditordMode1] = useState(true);
  const [ad, setAD] = useState(null);
  const [itemm, setItemm] = useState(null);
  const [responseDataArray, setResponseDataArray] = useState([]);
  const [dataFetchingCompleted, setDataFetchingCompleted] = useState();
  const [qty, setQty] = useState(0);
  const [amt, setAmt] = useState(0);

  useEffect(() => {
    setAllData(null);
    setStoreData(null);
    setAD(null);

    axios
      .get(employeeData.URL + "/api/v1/purchaseorder/" + id, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        setItemm(response.data.data);
        setDataFetchingCompleted(response.data.data.purreqDetail.length);
        // var amt = 0;
        var qty = 0;
        // for (var t = 0; t < response.data.data.invoiceTaxChargeDetail.length; t++) {
        //   setAmt((amt += parseInt(response.data.data.invoiceSize[t].amount2)));
        // }
        //     // console.log(amt);
        let totalTaxValue = 0;
        let totalRunningTotal = 0;

        for (
          let t = 0;
          t < response.data.data.purchaseTaxChargeDetail.length;
          t++
        ) {
          const item = response.data.data.purchaseTaxChargeDetail[t];

          // Calculate the total taxValue regardless of charge_desc
          const taxValue = parseFloat(item.taxvalue || 0);
          totalTaxValue += taxValue;

          // Calculate the total runningTotal only where charge_desc === "basic"
          if (item.charge_desc === "basic") {
            const runningTotal = parseFloat(item.runningtotal || 0);
            totalRunningTotal += runningTotal;
          }
        }

        // Combine the totals
        const finalAmount = totalTaxValue + totalRunningTotal;

        // Set the final amount using setAmt
        setAmt(finalAmount);
        //     setTimeout(() => {
        //         document.getElementById("amt").value = amt;
        //     }, 2000);

        //  var qty = 0;
        for (var t = 0; t < response.data.data.purreqDetail.length; t++) {
          setQty(
            (qty += parseInt(response.data.data.purreqDetail[t].total_qty))
          );
        }

        setAllData((allData) => {
          let newDetails = response.data.data;

          // Modify reqDetail array to include Mode property with value true for each object
          newDetails.purreqDetail.forEach((detail) => {
            detail.Mode = true;
          });

          return {
            ...newDetails,
          };
        });

        setStoreData((storeData) => {
          let newDetails = response.data.data;

          return {
            ...newDetails,
          };
        });
      })
      .catch((error) => {
        // console.log(error);
      });

    axios
      .get(employeeData.URL + "/api/v1/purchaseorder/additional-data", {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);
        setAD((ad) => {
          let newad = response.data.data;
          return {
            ...newad,
            TYPE: {
              fields: [{ name: "key" }, { name: "value" }],
              rows: [
                { key: "wr", value: "With Requisition" },
                { key: "w", value: "Without Requisition" },
              ],
            },
            Dis_On: {
              fields: [{ name: "key" }, { name: "value" }],
              rows: [
                { key: "r", value: "Rate" },
                { key: "ta", value: "Total Amt" },
              ],
            },
            Dis_Type: {
              fields: [{ name: "key" }, { name: "value" }],
              rows: [
                { key: "p", value: "%" },
                { key: "a", value: "A" },
              ],
            },
          };
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async (item, index) => {
      try {
        // console.log(item.item_code);
        const response = await axios.get(
          `${employeeData.URL}/api/v1/purchaseorder/additional-data-of-hsn/${item.item_code}`,
          {
            withCredentials: true,
          }
        );
        // console.log(response.data.data);
        const data = response.data.data;
        setResponseDataArray((prevDataArray) => {
          const newArray = [...prevDataArray];
          newArray[index] = data; // Set the response data at the correct index
          return newArray;
        });
      } catch (error) {
        console.error(
          `Error fetching data for item_code ${item.item_code}:`,
          error
        );
      }
    };

    const fetchAllData = async () => {
      if (!itemm || !itemm.purreqDetail) {
        console.error(
          "itemm or itemm.purreqDetail is null or undefined",
          itemm
        );
        return;
      }

      try {
        await Promise.all(
          itemm.purreqDetail.map((item, index) => fetchData(item, index))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData().then(() => {
      // console.log(responseDataArray.length);
      // console.log(responseDataArray.length);
    });
  }, [itemm, setResponseDataArray]);
  // const isValidObject = (obj) => {
  //   return obj.size && obj.grade && obj.uom && obj.cost;
  // };

  // // Determine if all objects in responseDataArray meet the condition
  // const allObjectsValid = responseDataArray.every(isValidObject);

  const handleEditButtonClick = () => {
    setEditMode(true);
    setEditDode(true);
  };

  const handleSave = (event) => {
    // console.log(storeData, "this is store data");
    // console.log(storeData, "this is store data");
    const postData = {
      ...allData,
    };

    // const postDataS = {
    //   ...storeData,
    //   purreqDetail: allData.purreqDetail.map((dep) => {
    //     return {
    //       ...dep,
    //     };
    //   }),
    // };

    // console.log(postData);
    // console.log(postData);
    // console.log(postData);

    // Filter out undefined elements from reqDetail array
    postData.purreqDetail = postData.purreqDetail.filter(
      (detail) => detail !== null && detail !== undefined
    );

    // Process the filtered array
    postData.purreqDetail.forEach((lang, index) => {
      if (!lang.unique_code) {
        postData.purreqDetail[index] = {
          ...lang,
          PARAM: "INSERT",
        };
      } else {
        postData.purreqDetail[index] = {
          ...lang,
          PARAM: "UPDATE",
        };
      }
    });

    storeData.purreqDetail.forEach((lang, index) => {
      const dataIndex = postData.purreqDetail.findIndex(
        (element) => element.unique_code === lang.unique_code
      );
      if (dataIndex === -1) {
        postData.purreqDetail.push({
          unique_code: lang.unique_code,
          PARAM: "DELETE",
        });
      }
    });

    let missingFields = [];

    console.log(allData);

    if (allData.poHdr[0].deal_date == null) {
      missingFields.push("Deal Date");
    }
    if (allData.poHdr[0].deal_type_cd == null) {
      missingFields.push("Deal Type");
    }
    if (allData.poHdr[0].currency_cd == null) {
      missingFields.push("Currency ");
    }
    if (
      allData.poHdr[0].currency_rate1 == null ||
      allData.poHdr[0].currency_rate1 === ""
    ) {
      missingFields.push("Currency Rate");
    }
    if (allData.poHdr[0].party_code == null) {
      missingFields.push("Party");
    }
    if (allData.poHdr[0].po_type1 == null) {
      missingFields.push("PO Type");
    }
    if (allData.poHdr[0].po_ref == null || allData.poHdr[0].po_ref === "") {
      missingFields.push("PO Reference");
    }
    if (allData.poHdr[0].type == null) {
      missingFields.push(" Po Type");
    }

    // If there are missing fields, display an error message
    if (missingFields.length > 0) {
      message.error({
        content: `Please Fill The Mandatory Fields: ${missingFields.join(
          ", "
        )}!!!`,
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      setLoading(false);
      return; // Stop further execution if validation fails
    }

    const allFieldsNull = allData.purreqDetail.every(
      (detail) =>
        detail.item_code === null &&
        detail.uom_code === null &&
        detail.size_code === null &&
        detail.quality_code === null &&
        detail.total_qty === null &&
        detail.hsn === null &&
        detail.remarks === null &&
        detail.rate === null &&
        detail.amount === null &&
        detail.rate1 === null &&
        detail.amount2 === null
    );

    if (allFieldsNull) {
      message.error({
        content: "Please Fill At Least One Row In The Item Detail Tab!!!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      setLoading(false);
      return; // Stop further execution if all fields are null
    }

    //////////////////////with level
    const fieldDisplayNameMap = {
      item_code: "Item",
      uom_code: "Uom",
      size_code: "Size",
      quality_code: "Grade",
      total_qty: "Quantity",
      hsn: "HSN",

      rate: "Basic Rate",
      amount: "Amount",
    };

    const invalidRows = allData.purreqDetail.filter((detail, index) => {
      const mandatoryFields = [
        "item_code",
        "uom_code",
        "size_code",
        "quality_code",

        "hsn",
        "total_qty",

        "rate",
        "amount",
      ];
      const missingFields = mandatoryFields.filter(
        (field) =>
          detail[field] === null ||
          detail[field] === undefined ||
          detail[field] === ""
      );
      if (missingFields.length > 0) {
        // Map field names to display names
        const displayNames = missingFields.map(
          (field) => fieldDisplayNameMap[field]
        );
        // Construct error message for this row
        const errorMessage = `Row ${
          index + 1
        }: Please Fill All Mandatory Fields (${displayNames.join(", ")})`;
        // Display error message
        message.error({
          content: errorMessage,
          className: "custom-class",
          style: {
            marginTop: "1vh",
          },
        });

        setLoading(false);
        return true;
      }
      return false;
    });

    if (invalidRows.length > 0) {
      return; // Stop further execution if validation fails
    }

    // console.log(JSON.stringify(postData, undefined, 2));

    // if (
    //   postData.purreqHdr[0].plan_date == null ||
    //   postData.purreqHdr[0].requirement_date == null ||
    //   postData.purreqHdr[0].dept_code == null ||
    //   postData.purreqHdr[0].requester_code == null
    // ) {
    //   message.error({
    //     content: "Please Fill The Mandatory Fields!!!",
    //     className: "custom-class",
    //     style: {
    //       marginTop: "1vh",
    //     },
    //   });
    //   setLoading(false);
    //   return; // Stop further execution if validation fails
    // }

    // const allFieldsNull = postData.purreqDetail.every(
    //   (detail) =>
    //     detail.item_code === null &&
    //     detail.uom_code === null &&
    //     detail.size_code === null &&
    //     detail.quality_code === null &&
    //     detail.purpose === null &&
    //     detail.actual_bal === null &&
    //     detail.qty === null
    // );

    // if (allFieldsNull) {
    //   message.error({
    //     content: "Please Fill At Least One Row In The Item Detail Tab!!!",
    //     className: "custom-class",
    //     style: {
    //       marginTop: "1vh",
    //     },
    //   });
    //   setLoading(false);
    //   return; // Stop further execution if all fields are null
    // }

    // const fieldDisplayNameMap = {
    //   item_code: "Item",
    //   size_code: "Size",
    //   quality_code: "Grade",

    //   qty: "Quantity",
    //   uom_code: "Uom",
    // };

    // const invalidRows = postData.purreqDetail.filter((detail, index) => {
    //   if (detail.PARAM === "DELETE") {
    //     return false;
    //   }
    //   const mandatoryFields = [
    //     "item_code",
    //     "size_code",
    //     "quality_code",

    //     "qty",
    //     "uom_code",
    //   ];
    //   const missingFields = mandatoryFields.filter(
    //     (field) =>
    //       detail[field] === null ||
    //       detail[field] === undefined ||
    //       detail[field] === ""
    //   );
    //   if (missingFields.length > 0) {
    //     // Map field names to display names
    //     const displayNames = missingFields.map(
    //       (field) => fieldDisplayNameMap[field]
    //     );
    //     // Construct error message for this row
    //     const errorMessage = `Row ${
    //       index + 1
    //     }: Please Fill All Mandatory Fields (${displayNames.join(", ")})`;
    //     // Display error message
    //     message.error({
    //       content: errorMessage,
    //       className: "custom-class",
    //       style: {
    //         marginTop: "1vh",
    //       },
    //     });

    //     setLoading(false);
    //     return true;
    //   }
    //   return false;
    // });
    // if (invalidRows.length > 0) {
    //   return; // Stop further execution if validation fails
    // }
    if (!postData.chargedata) {
      // Display error message
      // alert("Please calculate tax in the tax detail tab.");
      message.error({
        content: "Please calculate tax in the tax detail tab.!!!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      setLoading(false);
      return;
      // Prevent further execution
    }
    console.log(postData);

    axios
      .patch(employeeData.URL + "/api/v1/purchaseorder/" + id, postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        message.success({
          content: "requisition Updated Successfully!!!",
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
        setLoading(false);
        history("/purchase/transaction/purchase-order");
      })
      .catch((err) => {
        message.error({
          content: "An Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
        setLoading(false);
      });

    // setEditMode(false);
  };

  const handleCancel = (event) => {
    setLoading(false);
    history("/purchase/transaction/purchase-order");
  };

  return (
    <>
      {allData && ad && responseDataArray.length === dataFetchingCompleted ? (
        <Row className={classes["RowP"]}>
          <Col
            lg={editMode ? 13 : 19}
            md={editMode ? 13 : 19}
            className={classes["Col"]}
          ></Col>
          {editMode ? (
            <>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleSave(event)}
                    className={classes["ProfileButtonn"]}
                    id="save"
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                  >
                    Save
                  </button>
                )}
              </Col>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleCancel(event)}
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                    className={classes["ProfileButtonn"]}
                  >
                    Cancel
                  </button>
                )}
              </Col>
            </>
          ) : (
            <Col md={4}>
              <button
                onClick={handleEditButtonClick}
                className={classes["ProfileButton"]}
              >
                Edit Details
              </button>
            </Col>
          )}
          <Col lg={1} md={1}></Col>
          <Col lg={24} md={24} className={classes["Col"]}>
            <div className={classes["EditView"]}>
              <Col
                style={{
                  // border: "2px solid red",
                  marginTop: "5px",
                  marginBottom: "-28px",
                }}
              >
                <span style={{ fontWeight: "bold", color: "#1677ff" }}>
                  Purchase Order
                </span>

                <BasicDetail
                  create={true}
                  ad={ad}
                  setData={setAllData}
                  // editordMode1={editordMode1}
                  data={allData.poHdr[0]}
                  editMode={editMode}
                  netQty={qty}
                  setQty={setQty}
                  setAmount={setAmt}
                  netAmount={amt}
                />
              </Col>
              <Tabs
                defaultActiveKey="0"
                centered // Center the Tabs
                type="line" // Set the type to "card"
                tabBarGutter="10"
                id="tabs"
                tabBarUnderlineStyle={{ borderWidth: 0 }} // Remove border from the tab bar
              >
                <TabPane
                  tab={
                    <span style={{ fontWeight: "bold", color: "000000" }}>
                      Item Details
                    </span>
                  }
                  key="0"
                  style={{
                    // border: "none !important",
                    // border: "2px solid black",
                    marginTop: "-16px",
                  }}
                >
                  <div
                    style={{
                      overflowX: "scroll",
                      // padding: "10px",
                      // border: "2px solid red",
                    }}
                  >
                    {dataFetchingCompleted && (
                      <SizeDetail
                        ad={ad}
                        setData={setAllData}
                        data={allData.purreqDetail}
                        editMode={editMode}
                        editDode={editDode}
                        setEditDode={setEditDode}
                        responseDataArray={responseDataArray}
                        lenght={dataFetchingCompleted}
                        setResponseDataArray={setResponseDataArray}
                        setDataFetchingCompleted={setDataFetchingCompleted}
                      />
                    )}
                  </div>
                </TabPane>
                <TabPane tab={<span>Order Tax Details</span>} key="1">
                  <TaxDetail
                    create={true}
                    ad={ad}
                    setData={setAllData}
                    data={allData.purchaseTaxChargeDetail}
                    editMode={editMode}
                    editTode={editTode}
                    setEditTode={setEditTode}
                    setQty={setQty}
                    setAmount={setAmt}
                  />
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default RequisitionView;
